(() => {
 const config=JSON.parse(document.getElementById('bb7-offer-config').textContent);
 const variants=Object.fromEntries(config.variants.map(v=>[Number(v.title.match(/\d+/)[0]),v]));
 const bundles=[...document.querySelectorAll('#bundles .bundle')];
 const ctas=['mainCta','closeCta','stickyBtn'].map(id=>document.getElementById(id)).filter(Boolean);
 const linkParams=new URLSearchParams(window.location.search);
 const linkedPack=Number(linkParams.get('pack'));
 const linkedVariant=Object.entries(variants).find(([,v])=>String(v.id)===linkParams.get('variant'));
 const linkedMode=linkParams.get('purchase');
 let selected=variants[linkedPack]?linkedPack:(linkedVariant?Number(linkedVariant[0]):3);
 let mode=['one_time','subscription'].includes(linkedMode)?linkedMode:'subscription',busy=false;
 const money=n=>new Intl.NumberFormat('da-DK',{style:'currency',currency:config.currency}).format(n/100);
 function render(){
  for(const b of bundles){const n=Number(b.dataset.qty),v=variants[n],a=v.allocations[0];
   const price=mode==='subscription'?a?.price:v.price;b.classList.toggle('sel',n===selected);b.setAttribute('aria-pressed',String(n===selected));
   b.querySelector('.per b').textContent=price==null?'Ikke tilgængelig':money(price/n);
   b.querySelector('.bb7-cadence').textContent=mode==='subscription'?`Hver ${n*4}. uge`:'Én levering';
  }
  document.querySelectorAll('[data-purchase-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.purchaseMode===mode)));
  const v=variants[selected],a=v.allocations[0],p=mode==='subscription'?a?.price:v.price;
  const valid=config.country==='DK'&&config.currency==='DKK'&&v.available&&p!=null;
  const shipping=selected===3?0:3900;
  document.querySelector('.bb7-outcome-note').hidden=mode!=='subscription';
  document.querySelector('.bb7-mode-note').textContent=mode==='subscription'?'Ingen binding. Spring over, sæt på pause eller opsig via din kundekonto.':'Engangskøb. Én betaling og én levering.';
  document.getElementById('bb7-order-summary').textContent=valid?`${selected} ${selected===1?'tube':'tuber'}: ${money(p)} + ${shipping?money(shipping)+' fragt':'gratis levering'}. I alt ${money(p+shipping)}${mode==='subscription'?` i dag og hver ${selected*4}. uge.`:' i dag. Ingen gentagne betalinger.'}`:'Dette tilbud er tilgængeligt i Danmark. Vælg Danmark som leveringsland.';
  for(const id of ['ctaNew','cNew'])document.getElementById(id).textContent=p==null?'':money(p);
  for(const id of ['ctaOld','cOld']){const e=document.getElementById(id);e.textContent=mode==='subscription'?money(v.price):'';e.hidden=mode!=='subscription';}
  document.querySelectorAll('.bb7-cta-label').forEach(e=>e.textContent=mode==='subscription'?'Start abonnement':'Bestil én gang');
  ctas.forEach(c=>c.setAttribute('aria-disabled',String(!valid||busy)));
 }
 bundles.forEach(b=>{const pick=()=>{selected=Number(b.dataset.qty);render()};b.addEventListener('click',pick);b.addEventListener('keydown',e=>{if(['Enter',' '].includes(e.key)){e.preventDefault();pick()}})});
 document.querySelectorAll('[data-purchase-mode]').forEach(b=>b.addEventListener('click',()=>{mode=b.dataset.purchaseMode;render()}));
 for(const c of ctas)c.addEventListener('click',async e=>{
  e.preventDefault();if(busy||c.getAttribute('aria-disabled')==='true')return;
  busy=true;render();const error=document.getElementById('bb7-error');error.hidden=true;
  try{const v=variants[selected],item={id:v.id,quantity:1,properties:{'_offer_test':'BB7-SUB-20261015'}};
   if(mode==='subscription'){if(!v.allocations[0])throw new Error('Abonnementet er ikke tilgængeligt.');item.selling_plan=v.allocations[0].id;}
   const root=config.root.replace(/\/$/,'');const response=await fetch(root+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
   const data=await response.json();if(!response.ok)throw new Error(data.description||'Kunne ikke tilføje pakken. Prøv igen.');window.location.assign(root+'/checkout');
  }catch(ex){error.textContent=ex.message;error.hidden=false;busy=false;render()}
 });
 render();
  const track = document.getElementById('gtrack');
  const thumbs = [...document.querySelectorAll('#thumbs img')];
  let slide = 0;
  const showSlide = (index) => {
    slide = Math.max(0, Math.min(thumbs.length - 1, index));
    if (track) track.style.transform = `translateX(-${slide * 100}%)`;
    thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === slide));
    const previous = document.getElementById('gprev');
    const next = document.getElementById('gnext');
    if (previous) previous.style.visibility = slide === 0 ? 'hidden' : 'visible';
    if (next) next.style.visibility = slide === thumbs.length - 1 ? 'hidden' : 'visible';
  };
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
  document.getElementById('gprev')?.addEventListener('click', () => showSlide(slide - 1));
  document.getElementById('gnext')?.addEventListener('click', () => showSlide(slide + 1));

  document.querySelectorAll('.faq .item .q').forEach((question) => {
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    const toggle = () => question.parentElement.classList.toggle('open');
    question.addEventListener('click', toggle);
    question.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });
})();
